(function() {
    //extend stringjs
    var oldTrimLeft = S.fn.trimLeft,
        oldTrimRight = S.fn.trimRight,
        oldTrim = S.fn.trim,
        oldEnsureLeft = S.fn.ensureLeft,
        oldEnsureRight = S.fn.ensureRight;

    S.empty = ''; //this should be removed

    S.getString = function() {
        var value;

        _.find(arguments, function(item) {
            if(fpUtil.isNull(item)) return;

            item = item.toString();
            if(item.length) {
                value = item;
                return true;
            }
        });

        if(!_.isString(value)) value = '';

        return value;
    };

    S.mixin({
        getString: function() {
            var args = _.toArray(arguments);
            args.unshift(this.s);
            return new this.constructor(S.getString.apply(S, args));
        },
        trimLeft: function (needle) {
            if (needle) {
                return new this.constructor(this.s.replace(new RegExp('^' + fpUtil.regExp.escape(needle) + '+', 'gi'), ''));
            }
            return oldTrimLeft.call(this);
        },
        trimRight: function (needle) {
            if (needle) {
                return new this.constructor(this.s.replace(new RegExp(fpUtil.regExp.escape(needle) + '+$', 'gi'), ''));
            }
            return oldTrimRight.call(this);
        },
        trim: function(needle) {
            if(needle) {
                needle = fpUtil.regExp.escape(needle);
                var s = this.s
                    .replace(new RegExp('^' + needle + '+', 'gi'), '')
                    .replace(new RegExp(needle + '+$', 'gi'), '');

                return new this.constructor(s);
            }

            return oldTrim.call(this);
        },
        ensureLeft: function (needle) {
            return oldEnsureLeft.call(this.trimLeft(needle), needle);
        },
        ensureRight: function (needle) {
            return oldEnsureRight.call(this.trimRight(needle), needle);
        },
        encodeForHtml: function() {
            if(!this.s.length) return this;
            return new this.constructor(fpUtil.encodeForHtml(this.s));
        },
        decodeForHtml: function() {
            if(!this.s.length) return this;
            return new this.constructor(fpUtil.decodeForHtml(this.s));
        },
        encodeUri: function() {
            if(!this.s.length) return this;
            return new this.constructor(encodeURIComponent(this.s));
        },
        decodeUri: function() {
            if(!this.s.length) return this;
            return new this.constructor(decodeURIComponent(this.s));
        },
        markdownToHtml: function() {
            if(!this.s.length) return this;

            var regExp = fpUtil.regExp.matchHtml;
            regExp.lastIndex = 0;
            return regExp.test(this.s) ? this : new this.constructor(fp.markdownConverter.makeHtml(this.s));
        },
        titleCase: function() {
            return this
                .toLowerCase()
                .replace(/(^[a-z]| [a-z]|-[a-z]|_[a-z])/g,
                    function($1){
                        return $1.toUpperCase();
                    }
                );
        },
        titlelize: function() {
            if(!this.s.length) return this;

            var matchSpecialChars = fpUtil.regExp.matchSpecialChars;
            matchSpecialChars.lastIndex = 0;

            var s = this
                .replace(matchSpecialChars, ' ')
                .titleCase();

            if(s.eq('Id') || s.eq('Upc')) {
                s = s.toUpperCase();
            }
            else if(s.endsWith(' Id')) {
                s = new this.constructor(s.trimRight(' Id').s + ' ID');
            }
            else if(s.endsWith(' Ids', true)) {
                s = new this.constructor(s.trimRight(' Ids').s + ' IDs');
            }

            return s;
        },
        clean: function(oldValue, newValue) { //recursively replaces all occurrences of oldValue with newValue
            if(S(oldValue).eq(newValue)) return this;

            if (oldValue instanceof S) oldValue = oldValue.s;
            if (newValue instanceof S) newValue = newValue.s;

            var value = this,
                count = 0;
            while(count < 10 && value.contains(oldValue)) {
                value = value.replaceAll(oldValue, newValue);
                count++;
            }
            return value;
        },
        append: function (value) {
            if (value instanceof S) value = value.s;
            return new this.constructor(this.s + value);
        },
        prepend: function (value) {
            if (value instanceof S) value = value.s;
            return new this.constructor(value + this.s);
        },
        concat: function (value) {
            return this.append(value);
        },
        eq: function(value, ignoreCase) {
            value = S.getString(value);
            var s = this.s;
            if(ignoreCase) {
                s = s.toLowerCase();
                value = value.toLowerCase();
            }
            return s === value;
        },
        ne: function(value, ignoreCase) {
            return !this.eq(value, ignoreCase);
        },
        startsWith: function(needle, ignoreCase) {
            needle = S.getString(needle);
            var s = this.s;
            if(ignoreCase) {
                s = s.toLowerCase();
                needle = needle.toLowerCase();
            }
            return s.lastIndexOf(needle, 0) === 0;
        },
        endsWith: function(needle, ignoreCase) {
            needle = S.getString(needle);
            var s = this.s;
            if(ignoreCase) {
                s = s.toLowerCase();
                needle = needle.toLowerCase();
            }
            var len  = s.length - needle.length;
            return len >= 0 && s.indexOf(needle, len) === len;
        },
        contains: function(needle, ignoreCase) {
            needle = S.getString(needle);
            var s = this.s;
            if(ignoreCase) {
                s = s.toLowerCase();
                needle = needle.toLowerCase();
            }
            return s.indexOf(needle) >= 0;
        },
        dasherize: function(separator) {
            separator = separator || '-';
            var s = this.trim().s.replace(/[_\s]+/g, separator).replace(/([A-Z])/g, '-$1').replace(/-+/g, separator).toLowerCase();
            return new this.constructor(s);
        },
        pluralize: function () {
            if (!this.s.length) return this;

            var value = this;
            if (this.endsWith('s')) {
                if(!this.endsWith('rs')) value = value.concat('es');
            }
            else if (value.endsWith('y')) value = value.trimRight('y').concat('ies');
            else value = value.concat('s');

            return value;
        },
        singular: function () {
            if (!this.s.length) return this;

            var value = this;
            if (this.endsWith('ses')) value = value.trimRight('es');
            else if (value.endsWith('ies')) value = value.trimRight('ies').concat('y');
            else if(!value.endsWith('us')) value = value.trimRight('s');

            return value;
        },
        trailingSlashIt: function() {
            var s = this.trim();
            if(s.s != '/') s = s.trimRight('/').concat(fpConfig.urlTrailingSlash ? '/' : '');
            return new this.constructor(s);
        },
        stripWhiteSpace: function() {
            return this.strip(' ', '\t');
        },
        ensureEnd: function(needle) {
            var s = this.s;
            if (this.endsWith('.') || this.endsWith('?') || this.endsWith('!'))  {
                return this;
            }
            else {
                needle = needle || '.';
                return new this.constructor(s + needle);
            }
        },
        isXml: function() {
            return this.startsWith('<?xml', true);
        }
    });
})();